<template lang="pug">
v-tooltip(bottom)
  template(#activator="{ on, attrs }")
    v-btn.mx-2.mr-0(
      v-bind="attrs"
      v-on="on"
      :disabled="isDisabled"
      :text="isText"
      :icon="!isText"
      :color="color()"
      :small="small"
      :x-small="xSmall"
      @click="$emit('perform', { link })"
    )
      v-hover(v-slot="{ hover }")
        v-icon(
          v-show="!!icon(hover)"
          :color="!isText ? color(hover) : null"
          :left="isText"
        )
          | {{ icon(hover) }}

      div(v-if="isText") {{ verb }}

  span
    span.text-md.font-weight-medium {{ title }}
    br
    span.font-weight-light {{ description }}
</template>

<script>
import { hasRel } from '@/helpers/rels'
import { selectClass, selectColor } from '@/helpers/styles'

export default {
  props: {
    action: Object,
    small: Boolean,
    xSmall: Boolean,
  },

  computed: {
    link () {
      return this.action || {}
    },

    verb () {
      return this.link.verb || this.link.title || this.link.name || this.link.eref
    },

    title () {
      return this.link.title || this.link.verb || this.link.name || this.link.eref
    },

    description () {
      return this.link.description
    },

    pin () {
      return this.link.states?.filter(state => state.name === 'Pin')[0] || {}
    },

    isText () {
      return !this.icon || hasRel(this.pin, 'Text') || hasRel(this.link, 'Text')
    },

    isIcon () {
      return this.link.icon || this.pin.icon
    },

    isDisabled () {
      return this.link.disabled || this.pin.disabled
    },
  },

  methods: {
    icon (active) {
      return active
        ? this.link.icon || this.pin.icon
        : this.pin.icon || this.link.icon
    },

    style (active) {
      if (active) return "primary--text"

      const { pin, link } = this
      return selectClass(pin.style || link.style)
    },

    color(active) {
      if (active) return 'primary'

      const { pin, link } = this
      const color = pin.color || link.color
      return color ? color : selectColor(pin.style || link.style)
    },
  },
}
</script>